"use strict";


// Проверка поддержки WebP
function checkWebPSupport() {
    // Используем Modernizr для проверки (modernizr-custom-3.6.0.js)
    return Modernizr.webp;
}

// Функция для обновления фона элемента на WebP
function updateBackgroundToWebP(element) {
    var currentBackground = element.style.backgroundImage;
    if (currentBackground.includes('url(')) {
        var imageUrl = currentBackground.slice(5, -2); // Убираем 'url(' и ')'
        // console.log(element.style.backgroundImage = "url('".concat(imageUrl, ".webp')"));
    }
}

// Функция для обновления атрибута data-poster на WebP
function updateDataPosterToWebP(element) {
    var posterUrl = element.getAttribute('data-poster');
    if (posterUrl) {
        element.setAttribute('data-poster', posterUrl + ".webp");
    }
}

// Если WebP поддерживается, запускаем логику
if (checkWebPSupport()) {
    // console.log('Ваш браузер поддерживает WebP!');

    // Функция для обработки элемента, как при добавлении, так и для начальной обработки
    var processElement = function processElement(element) {
        if (element.classList.contains('welcome_photo') || element.classList.contains('comment__photo') || element.classList.contains('vjs-poster') || element.classList.contains('pict_responsive_preview')) {
            updateBackgroundToWebP(element);
        }

        if (element.hasAttribute('data-poster')) {
            updateDataPosterToWebP(element);
        }
    };

    // Создаем MutationObserver для отслеживания добавления элементов
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    // Проверяем, что это элемент
                    processElement(node);
                }
            });
        });
    });

    // Начинаем наблюдение за всем документом для отслеживания новых элементов
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    // Первоначальная обработка уже существующих элементов
    document.querySelectorAll('.welcome_photo, .comment__photo, .vjs-poster, .pict_responsive_preview, [data-poster]').forEach(function (element) {
        return processElement(element);
    });
} else {
    // console.log('Ваш браузер не поддерживает WebP.');
}